/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetCorporationsCorporationIdContractsContractIdItemsNotFound
 */
export interface GetCorporationsCorporationIdContractsContractIdItemsNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetCorporationsCorporationIdContractsContractIdItemsNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetCorporationsCorporationIdContractsContractIdItemsNotFound interface.
 */
export function instanceOfGetCorporationsCorporationIdContractsContractIdItemsNotFound(value: object): value is GetCorporationsCorporationIdContractsContractIdItemsNotFound {
    return true;
}

export function GetCorporationsCorporationIdContractsContractIdItemsNotFoundFromJSON(json: any): GetCorporationsCorporationIdContractsContractIdItemsNotFound {
    return GetCorporationsCorporationIdContractsContractIdItemsNotFoundFromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdContractsContractIdItemsNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdContractsContractIdItemsNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetCorporationsCorporationIdContractsContractIdItemsNotFoundToJSON(json: any): GetCorporationsCorporationIdContractsContractIdItemsNotFound {
    return GetCorporationsCorporationIdContractsContractIdItemsNotFoundToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdContractsContractIdItemsNotFoundToJSONTyped(value?: GetCorporationsCorporationIdContractsContractIdItemsNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

